import { useState, useEffect, useContext } from "react";
import { sessionUid } from "./Diarys/CommonFunc";
import { AppContext } from "./Context/AppContext";

const address =  "ws://" + window.location.hostname + ":10502" + '/ws'

export function useWebSocket(props) {
    console.log(`useWebSocket`,sessionUid);
    const [connection, setConnection] = useState()
    
    function createSocket(){
        try {   
            console.log(`Status: Creating socket ${sessionUid}`);         
            const socket = new WebSocket(address + "?uid=" + sessionUid);
            setConnection(socket);
        } catch (e) {
            console.log(e);
        }
    }
    useEffect(()=> {
        createSocket()
    },[])

    useEffect(() => {
        if (connection) {
            connection.onopen = async function () {
                console.log(`Status: Connected ${sessionUid}`);
                // Send a ping every 10s
                // to keep the connection live
                setInterval(function(){
                    console.log(`pinging...`);
                    connection.send('ping');
                }, 10000);
            };
            connection.onclose = function(event) {
                console.log(`Status: Closed ${sessionUid}`);
                setTimeout(function() {
                    console.log(`Status: Reconnecting ${sessionUid}`);
                    createSocket();
                  }, 50000);
              };
              
            connection.onerror = function(err) {
                console.error('Socket encountered error: ', err.message, 'Closing socket');
                connection.close();
              };

            connection.onmessage = function (e) {
                console.log("Server: " + e.data + "\n");
                const data = JSON.parse(e.data);
                const topic = data?.topic;
                if(!topic){
                    return;
                }
                if(topic.startsWith('color'))
                {
                    props.setTheme(prev => ({...prev, color: data.payload}));
                }   
                else if(topic.startsWith('Events'))
                {
                   
                    return;
                }
               
            };
        }
    }, [connection]);

    return connection;
}